import { getUrlParameter } from '../../../admin/actions'
import { Base64 } from 'js-base64'

/**
 * Parse search url to specific filters
 *
 * @return {Object|null}
 */
export const searchParams = () => {
    const filters = getUrlParameter('search')

    if (!filters) {
        return null
    }

    let selectedFilters = {}

    filters.replace(/\s/g, '+')
        .split('~')
        .map(filter => filter.split('---'))
        .map(([name, key]) => {
            let element = {}
            element[name] = (name === 'name' ? Base64.decode(key) : key).split('___')
            return element
        })
        .forEach(filter => {
            Object.assign(selectedFilters, filter)
        })

    return selectedFilters
}

/**
 * Get search queries for setting browser history
 *
 * @param {Object} filters - filters object
 * @return {string}
 */
export const getBrowserHistoryFilters = (filters = null) => {
    if (!filters) {
        filters = [searchParams()]
    }

    filters = Object.values(filters)

    let searchQuery = []
    filters.forEach(filter => {
        searchQuery.push(
            Object.entries(filter)
                .filter(([_, key]) => key && key !== '')
                .map(([name, key]) => `${name}---${(Array.isArray(key) ? key.join('___') : (name === 'name' ? Base64.encode(key) : key))}`)
                .join('~')
        )
    })

    searchQuery = searchQuery
        .filter(query => query && query !== '')
        .join('~')

    const location = { search: getUrlParameter('search') }
    Object.assign(location, { search: searchQuery })

    return searchQuery === '' ? '#' : `search=${location.search}`
}
